import React from "react";
import { Link } from "react-router-dom";
import { Calculator, LineChart, Home, UserCheck } from "lucide-react";
import { Btn, SectionHeading } from "./ui";
import { LINKS, ROUTES } from "./data";

const CARDS = [
  { icon: Calculator, title: "Request a Home Value", desc: "Get a clear picture of what your home may be worth in today's market." },
  { icon: LineChart, title: "Build a Pricing Strategy", desc: "Work through a smart pricing plan before your home goes to market." },
  { icon: Home, title: "Prepare Your Home", desc: "Understand how to prepare and present your property for listing." },
  { icon: UserCheck, title: "Connect With a Listing Pro", desc: "Speak with a Wallstreet Realty listing professional about your options." },
];

export const SellerSection = () => (
  <section id="sell" className="py-16 lg:py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow="For Sellers"
        title="Sell With Strategy"
        subtitle="Wallstreet Realty helps homeowners understand their home value, prepare their property, and create a smart plan before going to market."
      />
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {CARDS.map((c) => (
          <div
            key={c.title}
            data-testid={`seller-card-${c.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="lift bg-[#F5F5F5] border border-[#E5E5E5] rounded-[20px] p-7"
          >
            <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center mb-5 shadow-sm">
              <c.icon className="text-[#C9A961]" size={22} />
            </div>
            <h3 className="font-heading font-bold text-[17px] text-[#2D2D37] leading-snug">{c.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-[#2D2D37]/65">{c.desc}</p>
          </div>
        ))}
      </div>
      <div className="mt-10">
        <Btn href={LINKS.sellers} variant="gold" testid="seller-home-value">Get My Home Value</Btn>
        <Link to={ROUTES.idx} data-testid="seller-idx-link" className="mt-4 inline-block text-sm font-medium text-[#254369] hover:text-[#C9A961] transition-colors">See what's for sale near you</Link>
      </div>
    </div>
  </section>
);
